import {
  NAMESPACE_LIVE,
  NAMESPACE_PREMATCH,
} from '../../constants/Context';
import {
  SET_LIVE_GRID_STAKE_TYPES,
  SET_PREMATCH_GRID_STAKE_TYPES,
} from '../betting-presentation/grid/actions';

function setStakeTypeGroupIds(prefix, { sportId, stakeGroupTypeIds }) {
  const state = getSavedStakeTypeGroupIds(prefix) || {};

  state[sportId] = stakeGroupTypeIds;

  global.localStorage.setItem(`${prefix}.stakeTypeGroupIds`, JSON.stringify(state));
}

export function getSavedStakeTypeGroupIds(prefix, sportId) {
  if (!global.localStorage) {
    return;
  }

  const json = global.localStorage.getItem(`${prefix}.stakeTypeGroupIds`);

  if (typeof json !== 'string') {
    return;
  }

  let stakeTypeGroupBySportId;

  try {
    stakeTypeGroupBySportId = JSON.parse(json);
  }
  catch (err) {
    console.error(err, { json });
  }

  // todo: test this
  return sportId ? stakeTypeGroupBySportId[sportId] : stakeTypeGroupBySportId;
}

export default function () {
  return (store) => (next) => (action) => {
    switch (action.type) {
      case SET_PREMATCH_GRID_STAKE_TYPES:
        setStakeTypeGroupIds(NAMESPACE_PREMATCH, action.payload);
        break;

      case SET_LIVE_GRID_STAKE_TYPES:
        setStakeTypeGroupIds(NAMESPACE_LIVE, action.payload);
        break;

      // no default
    }

    return next(action);
  };
}
